module.exports = __webpack_public_path__ + "img/_1.4d96cead.png";